import React from 'react';
import { UiIcon } from 'ui-components';
import { useScrollPosition } from 'hooks';
import { scrollTop } from 'utils';
import { useTranslation } from 'react-i18next';
import { StyledBackToTopButton } from './StyledBackToTopButton.styles';

/**
 * A button component that appears when the user scrolls down the page,
 * allowing them to quickly scroll back to the top with a smooth animation.
 *
 * @component
 * @returns {JSX.Element|null} The back-to-top button if the scroll position is beyond 1.5 times the viewport height, otherwise null.
 */
function BackToTopButton() {
  const { t } = useTranslation();
  const { scrollPosition } = useScrollPosition({
    shouldRegister: true,
  });

  if (scrollPosition < window.innerHeight * 1.5) return null;

  return (
    <StyledBackToTopButton onClick={() => scrollTop()}>
      <span className='text'>{t('layout:backToTop')}</span>
      <UiIcon icon='ri-arrow-up-line' color='#ffffff' hover='#ffffff' />
    </StyledBackToTopButton>
  );
}

export default BackToTopButton;
